import { Compositor } from './compositor';
export class EnvironmentCompositor extends Compositor {
    constructor(config) {
        super({
            videoStarter: config.videoStarter,
            stats: config.stats,
        });
        this.toolEngine = config.toolEngine;
    }
    postProcessingHook(context) {
        this.toolEngine.render(context);
    }
    stopCompositingHook() {
        this.toolEngine.disconnect();
    }
}
//# sourceMappingURL=environment_compositor.js.map